import React, { useState, useEffect } from "react";
import { LoadPanel } from "devextreme-react";
import { getNotificationApi } from "../../api/notificationApi";
import { useAuth } from "../../contexts/auth";
import CustomEmpty from "../customEmptyView/CustomEmpty";
import "./notification-all.scss";
import { useNavigate } from "react-router-dom";

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12;

  return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
};
const NotificationAll = ({ refreshKey }) => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();
  const navigate = useNavigate();
  const showNotification = async () => {
    try {
      setLoading(true);
      const response = await getNotificationApi(
        user?.companytransid,
        user?.customertransid,
      );

      setNotifications(response.data);
    } catch (error) {
      console.error("Error fetching notifications:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (refreshKey > 0) setNotifications([]);
    showNotification();
  }, [refreshKey]);

  const handleNavigateToTicket = (notification) => {
    if (!notification.ticketcode) return;

    navigate("/ticket/Details-of-Ticket", {
      state: {
        detailData: {
          ticketcode: notification.ticketcode,
        },
      },
    });
  };

  return (
    <>
      {loading && <LoadPanel visible={loading} />}
      <div className="notification-main-container-all">
        {!Array.isArray(notifications) || notifications.length === 0 ? (
          <CustomEmpty moduleName="Notifications" />
        ) : (
          notifications.map((notification, index) => (
            <div
              key={index}
              className="notification-container-all"
              onClick={() => handleNavigateToTicket(notification)}
            >
              <div className="notification-header">
                {/* Unread Indicator */}
                <div
                  className={`unread-indicator ${
                    notification.notificationstatus?.toLowerCase() === "unread"
                      ? "visible"
                      : ""
                  }`}
                >
                  <span className="unread-circle"></span>
                </div>

                {/* Content */}
                <div className="notification-details-all">
                  {/* Title */}
                  {/* <div className="notification-title">{notification.title}</div> */}

                  <div className="notification-title-row">
                    <div className="notification-title">
                      {notification.title
                        .replace(notification.ticketcode, "")
                        .trim()}
                    </div>

                    <span className="ticket-code">
                      {notification.ticketcode}
                    </span>
                  </div>
                  {/* Description */}
                  <div className="notification-description">
                    {notification.description}
                  </div>

                  {/* Created By */}
                  <div className="notification-createdby">
                    By: {notification.createdby}
                  </div>

                  {/* Date */}
                  <div className="notification-date-all">
                    {formatDate(notification.entrydate)}
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </>
  );
};

export default NotificationAll;
